import { Container, DisplayObject, Sprite } from 'pixi.js';
import Core from '../Core/Core';
import { app } from '../index';
import { ISharePayload } from '../SDK/SDKmessages';
import { createPixiText } from './Utils';
import { PayloadType } from '../SDK/PayloadType';

export class ShareHelpers {
    public static async createJackpotSharePayload(): Promise<any> {
        const intent = 'SHARE';
        const image = sgPlatform === 'fbinstant' ? await ShareHelpers.getJackpotBase64Async() : '';
        const text = 'Jackpot!';
        const data = {
            entryPoint: 'SHARED',
            payload: {
                type: PayloadType.JACKPOT_SHARE,
                fromId: Core.sdk.user.userId,
            },
        };

        return {
            intent,
            image,
            text,
            data,
        };
    }

    public static async createMapCompleteSharePayload(mapId: string): Promise<ISharePayload> {
        const intent = 'SHARE';
        const image =
            sgPlatform === 'fbinstant' ? await ShareHelpers.getMapCompleteBase64Async(mapId) : '';
        const text = Core.local.getText('MapCompleted');
        const data = {
            entryPoint: 'SHARED',
            payload: {
                type: PayloadType.MAP_COMPLETE_SHARE,
                mapId,
                fromId: Core.sdk.user.userId,
            },
        };

        return {
            intent,
            image,
            text,
            data,
        };
    }

    public static async getJackpotBase64Async(): Promise<string> {
        return ShareHelpers.getBase64(
            ...ShareHelpers.createPolaroid('fbshare-jackpot', Core.local.getText('JackpotCard'))
        );
    }

    public static async getMapCompleteBase64Async(mapId: string): Promise<string> {
        return ShareHelpers.getBase64(...(await this.getMapCompletePolaroid(mapId)));
    }

    public static getMapCompletePolaroid(mapId: string) {
        return ShareHelpers.createAvatarPolaroid(getSnapShot(mapId), getCardMessage(mapId));
    }

    private static async createAvatarPolaroid(textureId: string, text: string) {
        const avatar: Sprite = await ShareHelpers.getAvatarAsync();
        avatar.scale.set(140 / avatar.width);
        avatar.anchor.set(0.5);
        avatar.position.set(187.5, 366.5);
        return [avatar, ...this.createPolaroid(textureId, text)];
    }

    private static createPolaroid(textureId: string, text: string) {
        const snapShot: Sprite = new PIXI.Sprite(PIXI.utils.TextureCache[textureId]);
        const textSprite: Sprite = new Sprite();
        const cardText = createPixiText(
            text,
            new PIXI.Rectangle(
                snapShot.width * 0.48,
                snapShot.height * 0.88,
                snapShot.width * 0.9,
                snapShot.height * 0.3
            ),
            'Lobster-Regular',
            34,
            28,
            0x596691
        );
        cardText.anchor.set(0.5);
        cardText.rotation = -0.01;
        textSprite.addChild(cardText);
        return [snapShot, textSprite];
    }

    public static async getAvatarAsync(): Promise<Sprite> {
        const avatar: Sprite = new Sprite();
        avatar.anchor.set(0.5);
        await new Promise<HTMLImageElement>((resolve, reject) => {
            const img: HTMLImageElement = new Image();
            img.crossOrigin = 'anonymous';
            img.src = Core.sdk.user.avatar;
            img.onload = () => resolve(img);
            img.onerror = () => reject();
        }).then((img: HTMLImageElement) => (avatar.texture = PIXI.Texture.from(img)));
        return avatar;
    }

    private static getBase64(...args: DisplayObject[]): string {
        const container: Container = new Container();
        args.forEach((child: DisplayObject) => container.addChild(child));
        return app.renderer.extract.base64(container);
    }
}

export function getCardMessage(mapId: string): string {
    let msg = Core.local.getText('GreetingsCard');
    msg = msg.replace('<PLACE>', Core.local.getText(mapId));
    return msg;
}

export function getSnapShot(mapId: string): string {
    switch (mapId) {
        case 'machu':
            return 'fbshare-machu';
        case 'rome':
            return 'fbshare-rome';
        case 'seoul':
            return 'fbshare-seoul';
        case 'scotland':
            return 'fbshare-scotland';
        case 'morocco':
            return 'fbshare-morocco';
        default:
            return 'fbshare-rome';
    }
}
